import { render, staticRenderFns } from "./ImmobilizeButton.vue?vue&type=template&id=55a13528&"
import script from "./ImmobilizeButton.vue?vue&type=script&lang=js&"
export * from "./ImmobilizeButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports